// extracted by mini-css-extract-plugin
module.exports = {"titleAndDescCont":"styles_titleAndDescCont__Wox-5"};